import { useEffect, useState } from 'react';
import { Col, FormGroup, Label, CustomInput } from '@polichat/flamboyant';
import { useGlotaT } from '../../../../../../hooks/useGlotaTranslation';

function SelectChannelWaba({
  onUpdate,
  initialValue: { initialChannelCustomer, channelsWabaList },
  isEdit,
}) {
  const [wabaChannel, setWabaChannel] = useState({
    templateChannelCustomer: initialChannelCustomer,
  });
  const [channelLabel, setChannelLabel] = useState();

  // Traduções
  const templateChannelLabel = useGlotaT(
    'spa.messageBuilder.waba.templateChannelLabel'
  );

  const handleInputChange = ({ target: { name, value } }) => {
    setWabaChannel({
      [name]: Number(value),
    });
    onUpdate({
      [name]: Number(value),
    });
  };

  useEffect(() => {
    if (isEdit) {
      setChannelLabel(
        channelsWabaList.find(
          (channel) => channel.id === wabaChannel.templateChannelCustomer
        )
      );
    }
  }, [wabaChannel.templateChannelCustomer, isEdit]);

  return (
    <Col sm={12} md={6}>
      <FormGroup>
        <Label>{templateChannelLabel}</Label>
        <CustomInput
          type="select"
          id="template-customer-channel"
          name="templateChannelCustomer"
          value={wabaChannel.templateChannelCustomer}
          onChange={handleInputChange}
          required
          disabled={isEdit}
        >
          {!isEdit && channelsWabaList.map((channel) => (
            <option key={channel.id} value={channel.id}>
              {`${channel.name} - ${channel.phone}`}
            </option>
          ))}
          {isEdit && channelLabel && (
            <option key={channelLabel.id} value={channelLabel.id}>
              {`${channelLabel.name} - ${channelLabel.phone}`}
            </option>
          )}
        </CustomInput>
      </FormGroup>
    </Col>
  );
}

export default SelectChannelWaba;
